/* global axios */
// =============================================================================
// Giphy API client — talks to our same-origin proxy (GIPHY_API_KEY stays
// server-side). search/trending return a trimmed list:
//   { id, title, preview (small animated for the grid), gif (downsized for send) }
// mediaUrl() builds the proxied URL the composer fetches to get a CORS-free blob
// it can attach as a File (Telegram renders a gif document as an animation).
// =============================================================================
const BASE = '/integrations/giphy';

const GiphyAPI = {
  async search(q, { limit = 24 } = {}) {
    const resp = await axios.get(`${BASE}/search`, { params: { q, limit } });
    return resp?.data?.data ?? [];
  },
  async trending({ limit = 24 } = {}) {
    const resp = await axios.get(`${BASE}/trending`, { params: { limit } });
    return resp?.data?.data ?? [];
  },
  // Fetch a gif's bytes THROUGH our proxy using the app's axios instance, so the
  // request carries Chatwoot's auth headers (a raw fetch() hits the auth gate and
  // 401s). Returns a Blob the composer wraps in a File.
  async fetchGifBlob(giphyUrl) {
    const resp = await axios.get(`${BASE}/media`, {
      params: { url: giphyUrl },
      responseType: 'blob',
    });
    return resp.data;
  },
};

export default GiphyAPI;
